import { useContext } from "react";
import { UserPermissionsContext } from "core/shared/presenter/UserPermissionsProvider";

const useUserPermissions = () => {
  const context = useContext(UserPermissionsContext);
  return context;
};

export default useUserPermissions;
